import { useEffect } from "react";
import useEmblaCarousel from "embla-carousel-react";
import AutoScroll from "embla-carousel-auto-scroll";
import "./carousel.css";

// Easy to add new posters - just add the filename here
const posters = [
  "heated-rivalry.jpg",
  "godzilla-minus-zero.jpg",
  "sunrise-on-the-reaping.jpg",
  "wicker.jpg",
  "la-bola-negra.jpg",
  "tuner.jpg",
  "buddy.jpg",
  "fall-2.jpg",
  "furious.jpg",
  "die-my-love.jpg",
  "housemaid.jpg",
  "jjk.jpg",
  "iron-lung.jpg",
  "michael.jpg",
  "great-awake.jpg",
  "kill-bill.jpg",
  "we-bury.jpg",
  "shelter.jpg",
  "silent-hill.jpg",
  "good-luck.jpg",
  "dracula.jpg",
  "now-you-see-me.jpg",
  "best-christmas.jpg",
  "boys-in-the-boat.jpg",
  "color-purple.jpg",
  "fight-or-flight.jpg",
  "godzilla-minus-one.jpg",
  "jesus-revolution.jpg",
  "land-of-bad.jpg",
  "last-supper.jpg",
  "my-hero.jpg",
  "radical.jpg",
  "reagan.jpg",
  "saw-x.jpg",
  "songbird.jpg",
  "sound-of-freedom.jpg",
  "the-apprentice.jpg",
  "the-boy-and-the-heron.jpg",
  "the-chosen.jpg",
  "the-hill.jpg",
  "the-last-showgirl.jpg",
  "the-long-game.jpg",
  "the-substance.jpg",
  "unsung-hero.jpg",
  "wick4.jpg",
  "young-woman-and-the-sea.jpg",
];

const Posters = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      loop: true,
      dragFree: true,
      align: "start",
    },
    [
      AutoScroll({
        playOnInit: true,
        speed: 1.2,
        stopOnInteraction: false,
        stopOnMouseEnter: true,
      }),
    ],
  );

  // Enable horizontal wheel/trackpad scrolling
  useEffect(() => {
    if (!emblaApi) return;

    const viewport = emblaApi.rootNode();
    let wheelDelta = 0;

    const handleWheel = (e) => {
      // Only respond to horizontal scroll
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        e.preventDefault();

        // Accumulate delta
        wheelDelta += e.deltaX;

        const threshold = 200; // Much higher threshold

        if (Math.abs(wheelDelta) >= threshold) {
          if (wheelDelta > 0) {
            emblaApi.scrollNext();
          } else {
            emblaApi.scrollPrev();
          }
          wheelDelta = 0;
        }
      }
    };

    viewport.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      viewport.removeEventListener("wheel", handleWheel);
    };
  }, [emblaApi]);

  return (
    <div className="embla-posters">
      <div className="embla-posters__viewport" ref={emblaRef}>
        <div className="embla-posters__container">
          {posters.map((poster, index) => (
            <div className="embla-posters__slide" key={index}>
              <img
                src={`./images/posters/${poster}`}
                height="250"
                width="167"
                alt={poster.replace(/[-_.]|jpg|png/gi, " ").trim()}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Posters;
